import { UserManager, WebStorageStateStore } from "oidc-client-ts";

const CALLBACK_URL = `${window.location.origin}/auth/callback`;
const POST_LOGOUT_URL = `${window.location.origin}/`;

const userManager = new UserManager({
  authority: `${import.meta.env.VITE_AUTH_URL}/realms/${import.meta.env.VITE_AUTH_REALM}`,
  client_id: import.meta.env.VITE_AUTH_CLIENT_ID,

  redirect_uri: CALLBACK_URL,
  post_logout_redirect_uri: POST_LOGOUT_URL,

  response_type: "code",

  automaticSilentRenew: true,
  accessTokenExpiringNotificationTimeInSeconds: 60,

  silent_redirect_uri: CALLBACK_URL,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});

declare module 'oidc-client-ts' {
  interface IdTokenClaims {
    groups?: string[];
  }
}

userManager.events.addUserLoaded((user) => {
  console.log("User loaded", user);
});

export const login = () => {
  const params = new URLSearchParams(window.location.search);
  return userManager.signinRedirect({ state: { redirect: params.get("redirect") } });
};

export const logout = () => {
  return userManager.signoutRedirect();
};

export const isLoggedIn = async () => {
  const user = await userManager.getUser();
  return !!user;
};

export const getAccessToken = async () => {
  const user = await userManager.getUser();

  if (user?.expired) userManager.signoutRedirect();

  return user?.access_token;
};

export const handleCallback = async () => {
  return userManager.signinRedirectCallback(window.location.href);
};

export const getCurrentUser = async () => {
  const user = await userManager.getUser();
  return user;
};
